import RowServiziContainer from './RowServiziContainer';

export default RowServiziContainer;
